import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IconColor, IconImage, IconSize } from '@interfaces/common.interface';

@Component({
  selector: 'ark-icon-svg',
  templateUrl: './icon-svg.component.html',
  styleUrls: ['./icon-svg.component.scss'],
})
export class IconSvgComponent {
  _icon: string = 'default';
  @Input() set icon(icon: string) {
    this._icon = icon;
    setTimeout(() => {
      this.iconPath = `/assets/icons/mobile/${icon}.svg`;
      this.cdr.detectChanges();
    });
  }

  get icon(): string {
    return this._icon;
  }

  @Input() color: IconColor = 'dark2';
  @Input() size: IconSize = 'small';
  @Input() pathStyle = false;

  iconPath = '';

  constructor(private cdr: ChangeDetectorRef) {}
}
